import { gql } from "@apollo/client";

export const CREATE_MANY_ORDER = gql`
  mutation CreateManyOrder(
    $data: [OrderCreateManyInput!]!
    $oneOffPaymentMethodId: String
    $cardPaymentIntentIds: [String!]
    $savedPaymentMethodType: String
  ) {
    createManyOrder(
      data: $data
      oneOffPaymentMethodId: $oneOffPaymentMethodId
      cardPaymentIntentIds: $cardPaymentIntentIds
      savedPaymentMethodType: $savedPaymentMethodType
    ) {
      count
    }
  }
`;

export const PREPARE_CARD_CHECKOUT_PAYMENT = gql`
  mutation PrepareCardCheckoutPayment(
    $data: [OrderCreateManyInput!]!
    $oneOffPaymentMethodId: String
    $savedPaymentMethodType: String
  ) {
    prepareCardCheckoutPayment(
      data: $data
      oneOffPaymentMethodId: $oneOffPaymentMethodId
      savedPaymentMethodType: $savedPaymentMethodType
    ) {
      cardPaymentMethodId
      authorizations {
        sellerId
        orderNumber
        paymentIntentId
        clientSecret
      }
    }
  }
`;

export const UPDATE_ORDER = gql`
  mutation UpdateOrder($data: OrderUpdateInput!, $where: OrderWhereUniqueInput!) {
    updateOrder(data: $data, where: $where) {
       id
      orderNumber
      createdAt
      totalAmount
      isConfirmed
      Product {
        id
      }
      ShippingMethod {
        id
        key
        name
      }
    }
  }
`;

export const UPDATE_MANY_ORDER = gql`
  mutation UpdateManyOrder($data: OrderUpdateManyMutationInput!, $where: OrderWhereInput, $pickupDate: String) {
    updateManyOrder(data: $data, where: $where, pickupDate: $pickupDate) {
       count
    }
  }
`;

export const LAST_BUYER_ORDER_PAYMENT_TYPE = gql`
  query LastBuyerOrderPaymentType(
    $where: OrderWhereInput
    $orderBy: [OrderOrderByWithRelationInput!]
    $take: Int
  ) {
    findManyOrder(where: $where, orderBy: $orderBy, take: $take) {
      paymentType
    }
  }
`;

export const ORDERS = gql`
   query FindManyOrder($where: OrderWhereInput, $orderBy: [OrderOrderByWithRelationInput!]) {
    findManyOrder(where: $where, orderBy: $orderBy) {
      id
      orderNumber
      createdAt
      totalAmount
      isConfirmed
      shippingFee
      isShippingPaidBySeller
      shippingMethodId
      quantity
      tradeNetFee
      shippingStatus
      paymentStatus
      fedExInsurance
      paymentType
      stripeTransactionId
      status
      trackingNumber
      Seller {
        id
        legalName
        PharmacyAddress {
          id
          address
          city
          State {
            id
            code
          }
          zipCode
        }
        deaNumber
        PharmacyLicensedStates {
          id
          State {
            id
            name
          }
        }
      }
      SellerUser {
        id
        firstName
        lastName
        BankAccount {
          bankName
          accountHolderName
          last4
          routingNumber
        }
      }
      Buyer {
        id
        legalName
        BankAccount {
          object
        }
        PharmacyAddress {
          id
          address
          city
          State {
            id
            code
          }
          zipCode
        }
        deaNumber
        PharmacyLicensedStates {
          id
          State {
            id
            name
          }
        }
      }
      BuyerUser {
        firstName
        lastName
        BankAccount {
          bankName
          accountHolderName
          last4
          routingNumber
        }
      }
      Product {
        id
        drugName
        expDate
        form
        isFrozen
        labelerName
        lotNumber
        ndc
        notes
        packageCondition
        sealDetails
        packaging
        pharmacyId
        price
        priceOption
        quantity
        quantityPerPack
        storage
        strength
        type
        wacDiscount
        unitPrice
        userId
      }
      OrderItemSnapshot {
        id
        orderId
        drugName
        ndc
        labelerName
        form
        strength
        lotNumber
        expDate
        packageCondition
        packaging
        quantityPerPack
        isFrozen
        sealDetails
        type
        unitPriceSnapshot
        listPriceSnapshot
      }
      ShippingMethod {
        id
        key
        name
      }
      Label {
        id
        key
        name
        type
      }
      CheckList {
        id
        key
        name
        type
      }
    }
  }
`;

export const ORDER = gql`
   query FindUniqueOrder($where: OrderWhereUniqueInput!) {
    findUniqueOrder(where: $where) {
      id
      orderNumber
      createdAt
      totalAmount
      isConfirmed
      shippingFee
      isShippingPaidBySeller
      shippingMethodId
      quantity
      tradeNetFee
      shippingStatus
      paymentStatus
      status
      totalAmount
      trackingNumber
      fedExInsurance
      fedExPickupType
      price
      stripeTransactionId
      Seller {
        legalName
      }
      SellerUser {
        firstName
        lastName
        BankAccount {
          bankName
          accountHolderName
          last4
          routingNumber
        }
      }
      Buyer {
        legalName
      }
      BuyerUser {
        firstName
        lastName
        BankAccount {
          bankName
          accountHolderName
          last4
          routingNumber
        }
      }
      Product {
        id
        drugName
        expDate
        form
        isFrozen
        labelerName
        lotNumber
        ndc
        notes
        packageCondition
        sealDetails
        packaging
        pharmacyId
        price
        priceOption
        quantity
        quantityPerPack
        storage
        strength
        type
        wacDiscount
        unitPrice
        userId
      }
      OrderItemSnapshot {
        id
        orderId
        drugName
        ndc
        labelerName
        form
        strength
        lotNumber
        expDate
        packageCondition
        packaging
        quantityPerPack
        isFrozen
        sealDetails
        type
        unitPriceSnapshot
        listPriceSnapshot
      }
      ShippingMethod {
        id
        key
        name
      }
      Label {
        id
        key
        name
        type
      }
      CheckList {
        id
        key
        name
        type
      }
    }
  }
`;